// Environment variable utility - simplified to use only .env file
export const getEnvVar = (key, defaultValue = '') => {
  // In React apps, process.env is available during build and runtime
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key] || defaultValue;
  }
  return defaultValue;
};

// Use .env file directly - no more complex logic
export const BACKEND_URL = getEnvVar('REACT_APP_BACKEND_URL', 'https://v5-vg96.onrender.com');
export const NODE_ENV = getEnvVar('NODE_ENV', 'development');
export const IS_DEVELOPMENT = NODE_ENV === 'development';
export const IS_PRODUCTION = NODE_ENV === 'production';

// Environment configuration loaded
